import { LANGS, lang, setLang, t } from "@/i18n";

// DE / EN pill pair in the header. Same pill style as the window selector so
// the header reads as one control strip; `aria-pressed` carries the state for
// screen readers, the `active` class for everyone else.
export function LangToggle() {
  return (
    <div class="toolbar" role="group" aria-label={t("header.language")}>
      {LANGS.map((l) => (
        <button
          key={l}
          type="button"
          class={`window-pill ${lang.value === l ? "active" : ""}`}
          aria-pressed={lang.value === l}
          title={l === "de" ? t("lang.de") : t("lang.en")}
          onClick={() => setLang(l)}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
